import { Link, NavLink } from "react-router-dom";
import logo from "../images/logo.png";
import logoName from "../images/logo_name.png";
import curseforge from "../images/curseforge.svg";
import { FR } from 'country-flag-icons/react/3x2'
import {
  FaDownload,
  FaCode,
  FaYoutube,
  FaGithub,
  FaPlay,
  FaLightbulb,
  FaTimes,
  FaBars,
} from "react-icons/fa";
import { FaArrowRightToBracket, FaCalendarDays } from "react-icons/fa6";
import { useState, useEffect, useRef } from "react";
import { LoggedInfo } from "./LoggedInfo";
import { getUserAvatarUrl, hasPermission, isLogged } from "../Utils";
import clsx from "clsx";
import { useUser } from "../UserProvider";

export const NavBar = () => {
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const resourcesRef = useRef<HTMLDivElement>(null);
  const mobileMenuRef = useRef<HTMLDivElement>(null);
  const user = useUser().user;


  useEffect(() => {
    let touchStartX = 0;
    let touchEndX = 0;
    function handleClickOutside(event: MouseEvent) {
      if (
        resourcesRef.current &&
        !resourcesRef.current.contains(event.target as Node)
      ) {
        setResourcesOpen(false);
      }

      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target as Node) &&
        !(event.target as Element).closest('.mobile-menu-button')
      ) {
        setMobileMenuOpen(false);
      }
    }


    function handleTouchStart(event: TouchEvent) {
      touchStartX = event.touches[0].clientX;
    }

    function handleTouchEnd(event: TouchEvent) {
      touchEndX = event.changedTouches[0].clientX;
      handleSwipeGesture();
    }

    function handleSwipeGesture() {
      const swipeThreshold = 50;
      const deltaX = touchEndX - touchStartX;

      if (deltaX > swipeThreshold) {
        setMobileMenuOpen(true);
      } else if (deltaX < -swipeThreshold) {
        setMobileMenuOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleTouchStart);
    document.addEventListener("touchend", handleTouchEnd);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("touchend", handleTouchEnd);
    };
  }, []);



  useEffect(() => {

  }, [mobileMenuOpen]);

  return (
    <nav className="top-0 left-0 right-0 z-50 bg-white dark:bg-gray-900 shadow-md border-b border-gray-200 dark:border-gray-800" >
      <div className="container mx-auto flex items-center justify-between px-4 py-3 md:py-4" >
        {/* Menu gauche - version desktop */}
        <div className="hidden md:flex space-x-8">
          <CustomNavLink to="/suggestions" icon={<FaLightbulb />}>
            Suggestions
          </CustomNavLink>
          <CustomNavLink to="/projects" icon={<FaDownload />}>
            Projects
          </CustomNavLink>
        </div>

        {/* Bouton burger - version mobile */}
        <button
          className={`mobile-menu-button md:hidden text-gray-800 dark:text-gray-200 mr-4 transition-all ${mobileMenuOpen ? "z-50" : ""}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>

        {/* Logo centré */}
        <Link
          to="/"
          className="relative items-center md:absolute md:left-1/2 md:transform md:-translate-x-1/2 group"
        >
          <img
            src={logo}
            alt="Logo"
            className="absolute h-10 w-10 object-contain translate-x-[calc(50%+1.125rem)] transition-all duration-200 group-hover:opacity-0 group-hover:translate-x-0"
          />
          <img
            src={logoName}
            alt="Logo name"
            className="sm:block opacity-0 h-10 -z-10 object-contain transition-all duration-[450ms] delay-[100ms] group-hover:opacity-100"
          />
        </Link>

        {/* Menu droit */}
        <div className="flex items-center space-x-6">
          {/* Dropdown Resources */}
          <div className="relative" ref={resourcesRef}>
            <button
              onClick={() => setResourcesOpen((open) => !open)}
              aria-haspopup="true"
              aria-expanded={resourcesOpen}
              className={clsx(
                "hidden md:flex items-center space-x-2 text-gray-800 dark:text-gray-200 font-semibold hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors ",
                resourcesOpen && "text-emerald-600 dark:text-emerald-400"
              )}
            >
              <FaCode className="text-lg" />
              <span className="hidden sm:inline">Resources</span>
              <FaPlay
                className={clsx(
                  "transform transition-transform duration-200 hidden sm:inline",
                  resourcesOpen ? "rotate-90" : ""
                )}
              />
            </button>
            {resourcesOpen && (
              <div
                role="menu"
                className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-md shadow-lg border border-gray-200 dark:border-gray-700 py-1 z-50"
              >
                <a
                  href="https://youtube.iglee.fr"
                  role="menuitem"
                  className="flex items-center px-4 py-2 text-gray-800 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
                >
                  <FaYoutube className="mr-2" />
                  Youtube (<FR title="France" className="w-4 mt-1" />)
                </a>
                <a
                  href="https://git.iglee.fr"
                  role="menuitem"
                  className="flex items-center px-4 py-2 text-gray-800 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
                >
                  <FaGithub className="mr-2" />
                  Github
                </a>
                {(hasPermission(user, 3) && <Link
                  to={
                    process.env.NODE_ENV === "production" &&
                      !hasPermission(user, 3)
                      ? "/"
                      : "/modsinfos"
                  }
                  role="menuitem"
                  className="flex items-center px-4 py-2 text-gray-800 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
                >
                  <img
                    src={curseforge}
                    alt="Curseforge"
                    className="mr-2 h-5 w-5 object-contain"
                  />
                  Mods Infos (WIP)
                </Link>)}
              </div>
            )}
          </div>

          {/* Login / User info */}
          {!isLogged() ? (
            <a
              href={process.env.REACT_APP_API_URL + "/login" + (process.env.NODE_ENV !== "production" ? "?dev=true" : "")}
              className="flex items-center space-x-1 text-gray-800 dark:text-gray-200 hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors font-semibold"
            >
              <FaArrowRightToBracket size={24} className="sm:hidden" />
              <FaArrowRightToBracket className="hidden sm:block" />
              <span className="hidden sm:inline">Login</span>
            </a>
          ) : (
            <LoggedInfo />
          )}
        </div>
      </div>

      {/* Menu mobile */}
      {(
        <div

          ref={mobileMenuRef}
          className={`md:hidden fixed inset-0 z-40 bg-white dark:bg-gray-900 pt-16 overflow-y-auto transi-all max-w-[75%] ${mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}`}
        >
          {/*  <button
            className="mobile-menu-button md:hidden text-gray-800 dark:text-gray-200 mr-4 mt-2 ml-4"
            onClick={() => setMobileMenuOpen(false)}
            aria-label="Toggle menu"
          >
           <FaTimes size={24} />
          </button> */}

          <div className="container mx-auto px-4 py-6">
            <div className="flex flex-col space-y-6">
              <MobileNavLink to="/suggestions" icon={<FaLightbulb />} onClick={() => setMobileMenuOpen(false)}>
                Suggestions
              </MobileNavLink>

              <MobileNavLink to="/projects" icon={<FaDownload />} onClick={() => setMobileMenuOpen(false)}>
                Projects
              </MobileNavLink>

              <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
                <h3 className="text-gray-500 dark:text-gray-400 text-sm uppercase tracking-wider mb-2">
                  Resources
                </h3>

                <a
                  href="https://youtube.iglee.fr"
                  className="flex items-center py-3 text-gray-800 dark:text-gray-200 hover:text-emerald-600 dark:hover:text-emerald-400"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <FaYoutube className="mr-3" />
                  Youtube (<FR title="France" className="w-4 mt-1" />)
                </a>

                <a
                  href="https://git.iglee.fr"
                  className="flex items-center py-3 text-gray-800 dark:text-gray-200 hover:text-emerald-600 dark:hover:text-emerald-400"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <FaGithub className="mr-3" />
                  Github
                </a>

                {hasPermission(user, 3) && (<Link
                  to={
                    process.env.NODE_ENV === "production" &&
                      !hasPermission(user, 3)
                      ? "/"
                      : "/modsinfos"
                  }
                  className="flex items-center py-3 text-gray-800 dark:text-gray-200 hover:text-emerald-600 dark:hover:text-emerald-400"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <img
                    src={curseforge}
                    alt="Curseforge"
                    className="mr-3 h-5 w-5 object-contain"
                  />
                  Mods Infos (WIP)
                </Link>)}
              </div>

              <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
                {!isLogged() || user == null ? (
                  <a
                    href={process.env.REACT_APP_API_URL + "/login"}
                    className="flex items-center py-3 text-gray-800 dark:text-gray-200 hover:text-emerald-600 dark:hover:text-emerald-400"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    <FaArrowRightToBracket className="mr-3" />
                    Login
                  </a>
                ) : (
                  <div className="py-3">
                    {/* <LoggedInfo /> */}
                    <h3 className="text-gray-500 dark:text-gray-400 text-sm uppercase tracking-wider mb-2 flex items-center">
                      <img
                        src={getUserAvatarUrl(user)}
                        alt={user.username}
                        className="rounded-full w-5 h-5 mr-2 object-cover"
                      />
                      {user.username}
                    </h3>
                    <a
                      href="/contests"
                      className="flex items-center py-3 text-gray-800 dark:text-gray-200 hover:text-emerald-600 dark:hover:text-emerald-400"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      <FaCalendarDays className="mr-3" />
                      Contests
                    </a>
                    {hasPermission(user, 2) && (
                      <a
                        href="/uploadChests"
                        className="flex items-center py-3 text-gray-800 dark:text-gray-200 hover:text-emerald-600 dark:hover:text-emerald-400"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        <img
                          src={process.env.REACT_APP_API_URL + "/image/nec.gif"}
                          alt=""
                          className="mr-3 w-[1em] rounded-sm object-contain"
                        />
                        Upload Chest Textures
                      </a>
                    )}
                    {hasPermission(user, 3) && (
                      <a
                        href="/adminPanel"
                        className="flex items-center py-3 text-gray-800 dark:text-gray-200 hover:text-emerald-600 dark:hover:text-emerald-400"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        <img
                          src="https://miro.medium.com/v2/resize:fit:1400/1*5Hnnv0awfSv0BGcq1C522w.png"
                          alt=""
                          className="mr-3 rounded-sm w-[1em] object-contain"
                        />
                        Admin Panel
                      </a>
                    )}

                    <a
                      href="/logout"
                      className="flex items-center py-3 text-gray-800 dark:text-gray-200 hover:text-emerald-600 dark:hover:text-emerald-400"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      <FaArrowRightToBracket className="mr-3 rotate-180 " />
                      Logout
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

function CustomNavLink({
  to,
  icon,
  children,
}: {
  to: string;
  icon: React.ReactElement;
  children: React.ReactNode;
}) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        clsx(
          "flex items-center space-x-2 text-gray-800 dark:text-gray-200 hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors font-semibold text-lg",
          isActive &&
          "text-emerald-600 dark:text-emerald-400 border-b-2 border-emerald-600 dark:border-emerald-400"
        )
      }
    >
      {icon}
      <span>{children}</span>
    </NavLink>
  );
}

function MobileNavLink({
  to,
  icon,
  children,
  onClick,
}: {
  to: string;
  icon: React.ReactElement;
  children: React.ReactNode;
  onClick: () => void;
}) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        clsx(
          "flex items-center py-3 text-xl font-medium border-l-4",
          isActive
            ? "text-emerald-600 dark:text-emerald-400 border-emerald-600 dark:border-emerald-400 bg-emerald-50 dark:bg-emerald-900/20"
            : "text-gray-800 dark:text-gray-200 border-transparent hover:border-gray-300 dark:hover:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-800"
        )
      }
      onClick={onClick}
    >
      <span className="mr-3">{icon}</span>
      {children}
    </NavLink>
  );
}